import { css } from 'emotion';
import Link from 'next/link';
import React from 'react';

import analytics from 'site-react/core/Analytics';
import theme from 'site-react/theme';

const wrapperStyle = css`
  background-color: ${theme.colors.brandSecondary};
`;

const bannerStyle = css`
  color: ${theme.colors.neutral900};
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${theme.colors.neutral800};
    text-decoration: none;
  }

  &:active {
    color: ${theme.colors.neutral700};
  }
`;

const highlightedTextStyle = css`
  ${theme.contentText3}
  display:inline-block;
  padding: ${theme.spacing.base * 3}px ${theme.spacing.sm}px
    ${theme.spacing.base * 3}px ${theme.spacing.md}px;
  margin: 0;
`;

const fakeLinkStyle = css`
  ${theme.contentText3}
  color: inerit;
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;

const WorkplaceStrategyBanner = () => (
  <Link href="/workplace-strategy">
    {/* `href` is populated by next/link */}
    {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
    <a
      className={bannerStyle}
      onClick={() => {
        analytics.track('Workplace Strategy Banner Clicked');
      }}
    >
      <div className={wrapperStyle}>
        <span className={highlightedTextStyle}>
          <strong>Should you ditch the office?</strong> Find the best workplace
          strategy for your employees with our{' '}
          <span className={fakeLinkStyle}>free tool</span>
        </span>
      </div>
    </a>
  </Link>
);

export default WorkplaceStrategyBanner;
